import { render, staticRenderFns } from "./u-modal.vue?vue&type=template&id=4196f8a7&scoped=true&"
import script from "./u-modal.vue?vue&type=script&lang=js&"
export * from "./u-modal.vue?vue&type=script&lang=js&"
import style0 from "./u-modal.vue?vue&type=style&index=0&id=4196f8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4196f8a7",
  null
  
)

export default component.exports